module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/pdf-5b478.png";